import { useContext, useState } from "preact/hooks";
import { FC } from "react";
import { ShipmentDocument, ShipmentDocumentState } from "../entities/ShipmentDocument.ts";
import { Button, IconArrowBigRight, IconInfo, IconLink } from "@idg-web-platform/pulse";
import css from "./shipmentDocumentInfo.module.css";
import ReturnInformationDialog from "./returnInformationDialog.tsx";
import { AppUrl } from "../orderDetailsPage.tsx";
import analytics from "@idg-data-analytics-platform/analytics";

interface ShipmentDocumentInfoProps {
  document: ShipmentDocument;
}

export const ShipmentDocumentInfo: FC<ShipmentDocumentInfoProps> = ({ document }) => {
  const appUrl = useContext(AppUrl);

  const [isReturnInformationDialogOpen, setIsReturnInformationDialogOpen] = useState(false);

  const trackValidDocument = () => {
    analytics({
      event: "generic_return_label_clicked",
      team: "control",
    });
  };

  const trackTradeByteDocument = () => {
    analytics({
      event: "generic_tb_return_label_clicked",
      team: "control",
    });
  };

  const renderDocument = () => {
    switch (document.state) {
      case ShipmentDocumentState.NOT_AVAILABLE:
        return (
          <div className={css.returnLabelInfoContainer}>
            <p>Retourenschein und Label für dieses Paket:</p>
            <p>
              Um deine Bestellung zu retournieren kontaktiere bitte den{" "}
              <a
                href={`https://${appUrl}/c/account/contact?issue=return`}
                onClick={trackTradeByteDocument}
              >
                Kundenservice
              </a>
              .
            </p>
          </div>
        );
      case ShipmentDocumentState.EXPIRED:
        return (
          <div className={css.returnLabelInfoContainer}>
            <p>Retourenschein und Label für dieses Paket:</p>
            <p className={css.expiredMessage}>Zeitraum für Rückgabe beendet.</p>
          </div>
        );
      case ShipmentDocumentState.RETURNED:
        return (
          <div className={css.returnLabelInfoContainer}>
            <p>Retourenschein und Label für dieses Paket:</p>
            <p className={css.returnedMessage}>Paket bereits zurückgesendet.</p>
          </div>
        );
      case ShipmentDocumentState.VALID:
        return (
          <div className={css.returnLabelInfoContainer}>
            <div className={css.returnLabelHint}>
              <div className={css.returnLabelInfoAndButton}>
                <p>Retourenschein und Label für dieses Paket:</p>
                <div className={css.returnLabelPrintButton}>
                  {document.url && (
                    <IconLink
                      text="Ausdrucken"
                      href={document.url}
                      iconComponent={<IconArrowBigRight />}
                      iconPosition="right"
                      onClick={trackValidDocument}
                      // target/rel aren't in pulse IconLink's prop type (generic HTMLAttributes since
                      // the Preact 10 type split) but are forwarded to the underlying <a> at runtime.
                      {...{ target: "_blank", rel: "noopener noreferrer" }}
                    />
                  )}
                </div>
              </div>
              <Button
                text="Informationen zur Rücksendung"
                iconOnly
                className={css.returnLabelInfoButton}
                iconComponent={<IconInfo />}
                iconPosition="right"
                onClick={() => {
                  setIsReturnInformationDialogOpen(true);
                }}
              />
              <ReturnInformationDialog
                isOpen={isReturnInformationDialogOpen}
                onClose={() => {
                  setIsReturnInformationDialogOpen(false);
                }}
              />
            </div>
          </div>
        );
      default:
        return <div>default</div>;
    }
  };

  return renderDocument();
};
